// Hero background
export const heroBackground = 'https://rhs25qyoh1.ufs.sh/f/0ymxA19g3Q7lOftB05oUYRvzh0Iw9Dtm6cO78Laq1Gls5gZA';

//Core Team Members
export const CoreTeamMembers = [
    {
        "name": "Yuvraj Jindal",
        "role": "President",
        "username": "u_v.iii",
        "avatar": "https://slmjev5tnh.ufs.sh/f/pA2QHWP8eSdn2VaEnmRREQOjJFIBLgY5iHnZsCzbN7D3c4ma"
    },
    {
        "name": "Shubham Sagar",
        "role": "Vice-President",
        "username": "shubhamsagarrr",
        "avatar": "https://slmjev5tnh.ufs.sh/f/pA2QHWP8eSdn2jlYYZRREQOjJFIBLgY5iHnZsCzbN7D3c4ma"
    },
    {
        "name": "Dhruv Kalra",
        "role": "Vice-President",
        "username": "_dhruvkalra_",
        "avatar": "https://slmjev5tnh.ufs.sh/f/pA2QHWP8eSdnpAL3xXw8eSdncLj6mfDb84yw7pXZUW1zGiKM"
    },
    {
        "name": "Ishika Bhardwaj",
        "role": "Secretary",
        "username": "_eshika07",
        "avatar": "https://slmjev5tnh.ufs.sh/f/pA2QHWP8eSdnXS8INePOcRgnUyBzJs2WL4jXTNIS3xK71D8t"
    },
    {
        "name": "Aryan Badlani",
        "role": "Joint Secretary",
        "username": "_aryann07._",
        "avatar": "https://slmjev5tnh.ufs.sh/f/pA2QHWP8eSdnRzq35c4WkVlGtbiATNnfZ1PQDqah6wKeUOsM"
    },
    {
        "name": "Saksham Dohare",
        "role": "Treasurer",
        "username": "_saksham__dohare_",
        "avatar": "https://slmjev5tnh.ufs.sh/f/pA2QHWP8eSdneU6sju59dLjSUVvaDPIsmRXZ6GznxkoNp0H2"
    },
    {
        "name": "Mohit Rawat",
        "role": "Filmmaking Head",
        "username": "mohittt.png",
        "avatar": "https://slmjev5tnh.ufs.sh/f/pA2QHWP8eSdnUD1Mcnwu8jxRTYN2oXqUV1BntQdZpOceWHIF"
    },
    {
        "name": "Rishi Kant",
        "role": "Videography Head",
        "username": "rishikant______",
        "avatar": "https://slmjev5tnh.ufs.sh/f/pA2QHWP8eSdnasCO5Ph5GUu9hN3K87cdasnXPCjt21xwWVb6"
    },
    {
        "name": "Manya Mangla",
        "role": "Social Media Head",
        "username": "manyamanglaa",
        "avatar": "https://slmjev5tnh.ufs.sh/f/pA2QHWP8eSdnkNGSToxA4P2cy5vd0a3buhRQF6Mr7OJDwtoI"
    },
    {
        "name": "Kaustubh Sankritya",
        "role": "Content Head",
        "username": "kostheta1729",
        "avatar": "https://slmjev5tnh.ufs.sh/f/pA2QHWP8eSdnAutco02ZR27DavWMit08zxYOQEVBwdPneqTK"
    },
    {
        "name": "Ansh Dubey",
        "role": "Coverage Head",
        "username": "anshdubeyy",
        "avatar": "https://slmjev5tnh.ufs.sh/f/pA2QHWP8eSdnpUsbwq8eSdncLj6mfDb84yw7pXZUW1zGiKMC"
    },
    {
        "name": "Harshil Beriwal",
        "role": "Digital Head",
        "username": "harshil.beriwal",
        "avatar": "https://slmjev5tnh.ufs.sh/f/pA2QHWP8eSdn2TfGJeRREQOjJFIBLgY5iHnZsCzbN7D3c4ma"
    },
    {
        "name": "Kundan Kumar",
        "role": "Digital Head",
        "username": "_graper_09",
        "avatar": "https://slmjev5tnh.ufs.sh/f/pA2QHWP8eSdnDTBtjoUoy4WIt2UDRrldC9B1kHhZeuKcvaSN"
    },
    {
        "name": "Vedika Sharma",
        "role": "PR Head",
        "username": "vedika_ashwalayan",
        "avatar": "https://slmjev5tnh.ufs.sh/f/pA2QHWP8eSdnhuClG1XetvN5kLiSDGM9CqbEYXQAsIRK7H1F"
    },
    {
        "name": "Arjun Chaudhary",
        "role": "Sponsorship Head",
        "username": "notsoreal.10",
        "avatar": "https://slmjev5tnh.ufs.sh/f/pA2QHWP8eSdnqHkBbRrgWt0Vc7Ok3iTyxMdLoZ8GAbnFjQv2"
    },
    {
        "name": "Alisha Indwar",
        "role": "Competition Head",
        "username": "maryalisha__",
        "avatar": "https://slmjev5tnh.ufs.sh/f/pA2QHWP8eSdnAPn1942ZR27DavWMit08zxYOQEVBwdPneqTK"
    }
];

//Slider Images
export const slides = [
    "https://1sh6in86sy.ufs.sh/f/MZxlz3TQUfiqNUoBRStleU7R6HXWi9dPkLwb1QSsIzCmyrvT",
    "https://1sh6in86sy.ufs.sh/f/MZxlz3TQUfiqPMXpOw92Wzp0sn8LgHEleQ6u7YJmfUXT9ARr",
    "https://1sh6in86sy.ufs.sh/f/MZxlz3TQUfiq8k86td5mUP9MYpSBJtDEuNfh5k2bewlAIvxn",
    "https://1sh6in86sy.ufs.sh/f/MZxlz3TQUfiqjkY7mUq7lBCwoRX5LrMImTanvK3kpN0iDVuH",
    "https://1sh6in86sy.ufs.sh/f/MZxlz3TQUfiqseTqIkLbEqQ9NDeHkIUXZF8py6JvLAn0hS2a",
    "https://1sh6in86sy.ufs.sh/f/MZxlz3TQUfiqMS9pKaQUfiqyGL7XpEaVAh94rHguYDCx6Ink",
    "https://1sh6in86sy.ufs.sh/f/MZxlz3TQUfiqHkpS7uyOmiaIl2zBvrZJy5XFxMVn1UhWkqtY",
    "https://1sh6in86sy.ufs.sh/f/MZxlz3TQUfiqu4qTDty0y7PiTHskoIFrxUd5vbRgWXDwl8n2",
    "https://1sh6in86sy.ufs.sh/f/MZxlz3TQUfiqxVuxgE9W2qEF7lTIkW0tsznKRiJULVDjc3dN",
    "https://1sh6in86sy.ufs.sh/f/MZxlz3TQUfiqSkA4MRhrziP6YaghbsDl0F39o2AnMkyx5uQW",
];

//Events Data
export const Events = [
    {
        name: "LENS EYE",
        location: "ARSD CAMPUS",
        date: "24/02/25",
        time: "STARTING 10:00 AM",
        agenda: "In this fast-paced competition, shutterbugs demonstrate their prowess in capturing the essence of fleeting moments.",
        details: "Join us on <b>24th February</b> at <b>10:00 AM</b> in <b>ARSD Campus</b> for an exhilarating on-spot photography competition.",
        price: "₹30",
        image: "https://eytim95w0m.ufs.sh/f/9E19w1sYoF24xFoxQtP9ho0cnWK7HkwdIeUSRmaQ6GfuA1Zj",
        registrationurl: "https://forms.gle/k3oGCQMXjWDDxm7YA",
        eventmanageremail: "pixelation@arsd.du.ac.in"
    },
    {
        name: "CHRONO TALES",
        location: "ONLINE",
        date: "22/02/25",
        time: "Online",
        agenda: "Chrono Tales provides a virtual canvas for participants to weave captivating narratives through the lens of photography.",
        details: "Participate in <b>Chrono Tales</b>, our online photostory competition, and let your creativity shine.",
        price: "₹20",
        image: "https://eytim95w0m.ufs.sh/f/9E19w1sYoF24uoZgNrirQVW6hdsv59bGDtYOxl4kUgpAHCqe",
        registrationurl: "https://forms.gle/vUb4sEGQvy9MPYKh8",
        eventmanageremail: "pixelation@arsd.du.ac.in"
    },
    {
        name: "PIXINEMA",
        location: "ARSD CAMPUS",
        date: "25/02/25",
        time: "STARTING 11:00 AM",
        agenda: "Pixinema sparks creativity and camaraderie among participants who crafted compelling short films on the spot.",
        details: "Join us on <b>25th February</b> at <b>11:00 AM</b> in <b>ARSD Campus</b> for Pixinema, an exciting on-spot filmmaking challenge.",
        price: "₹80",
        image: "https://eytim95w0m.ufs.sh/f/9E19w1sYoF24WqcwTpjIgX1O40pze6i2yAE73ntmZSCFvrDs",
        registrationurl: "https://forms.gle/iihjrV5MqutRNuNe7",
        eventmanageremail: "pixelation@arsd.du.ac.in"
    }
];
